export default __webpack_public_path__ + "static/media/hand.cbd8a9b3.png";